export enum ApiPermissions {
    READ_SERVICES = 'read-services',
    CREATE_SERVICES = 'create-services',
    UPDATE_SERVICES = 'update-services',

    CREATE_PLANS = 'create-plans',
    UPDATE_PLANS = 'update-plans',
    DELETE_PLANS = 'delete-plans',
}
